import React from 'react';
import { TrendSalesType, TrendChartTypes } from 'utils/types';
import TrendChart from 'components/Charts/Line';
import BaseChartWidget from 'components/Charts/Widgets/BaseChartWidget';

interface Props {
  globalFilter: any;
  portfolio?: boolean;
}

const TrendChartWidget: React.FC<Props> = ({ globalFilter, portfolio = false }) => {
  return (
    <BaseChartWidget defaultType={TrendSalesType} title="Trend" types={TrendChartTypes}>
      {(clientId, type) => (
        <TrendChart
          type={type}
          clientID={clientId}
          globalFilter={globalFilter}
          portfolio={portfolio}
        />
      )}
    </BaseChartWidget>
  );
};

export default TrendChartWidget;
